export const getProfileState = (state) => state.profile;